var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:(`height: ${_vm.height}px; width: ${_vm.width}px;`),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 13","fill":"none"}},[_c('path',{attrs:{"id":"+","d":"M6.78261 5.69368H11.9526V7.30632H6.78261V12.5H5.16996V7.30632H0V5.69368H5.16996V0.5H6.78261V5.69368Z","fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }